import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../../Constantes";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

export const TituloTexto = ({titulo, texto, dir = 'flex-start'}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={dir}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: dir}}>
                <Typography sx={{
                    fontSize: !masSM ? 14 : 16,
                    fontWeight: 400,
                    lineHeight: 1.1,
                    textAlign: dir === 'flex-start' ? 'left' : 'center'
                }}>{texto}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: dir, mt: sCell ? 0 : -1}}>
                <Typography
                    sx={{
                        fontSize: !masSM ? 34 : 54,
                        fontWeight: 600,
                        fontFamily: NEGRITA,
                        lineHeight: 1.1,
                        textAlign: dir === 'flex-start' ? 'left' : 'center'
                    }}>{titulo}</Typography>

            </Grid>


        </Grid>
    )
}